import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from 'react-router-dom';

// tabs
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
// multiple select
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Chip from '@mui/material/Chip';
import OutlinedInput from '@mui/material/OutlinedInput';
import { Theme, useTheme } from '@mui/material/styles';

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';

// service
import ContactService from "../services/ContactService";
import ActionService from "../services/ActionService";
import DonationService from "../services/DonationService";
import OutputService from "../services/OutputService";
import TableService from "../services/TableService";

// components
import Output from "./OutputSH";


// mail
import emailjs from '@emailjs/browser';
import Donations from "./DonationsSH";
import AddDonation from "./AddDonation";
import Actions from "./Actions";


const Contact = props => {
    const { id } = useParams();
    let navigate = useNavigate();
    const info = (props.v) ? props.v : false;
    const addAction = (props.addAction) ? props.addAction : false;

    const initialContactState = {
        persona_id: null,
        primo_contatto: "",
        titolo: "",
        categoria: "",
        nome: "",
        cognome: "",
        attacco_lettera: "",
        indirizzo: "",
        civico: "",
        citta: "",
        cap: 0,
        provincia: "",
        telefono: 0,
        cellulare: 0,
        societa: "",
        email: "",
        sesso: "",
        privacy: "",
        provenienza: "",
        data_nascita: null,
        luogo_nascita: "",
        eta: 0,
        codice_fiscale: "",
        partita_iva: "",
        legame: "",
        tipologia: "",
        donazione_id: 0,
        ragione_sociale: "",
        data_colloquio_vol: null,
        corso_faf: false,
        testo_corso_faf: "",
        corso_vol: false,
        testo_corso_vol: "",
        data_colloquio_socio: null,
        data_socio: null,
        invalidita: false,
        perc_invalidita: 0,
        iscrizione_coll: false,
        pensione: false,
        codice: ""

    };


    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const [currentContact, setCurrentContact] = useState(initialContactState);
    const [donations, setDonations] = useState([]);
    const [actions, setActions] = useState([]);
    const [outputs, setOutputs] = useState([]);

    const [message, setMessage] = useState();

    const getContact = id => {
        ContactService.get(id)
            .then(response => {
                setCurrentContact({ ...response.data, categoria: response.data.categoria.split(",").map((item) => item.trim()) });
            })
            .catch(e => {
                console.log(e);
            });
        DonationService.get(id)
            .then(response => {
                setDonations(response.data);
            })
            .catch(e => {
                console.log(e);
            });
        ActionService.get(id)
            .then(response => {
                setActions(response.data);
            })
            .catch(e => {
                console.log(e);
            });
        OutputService.get(id)
            .then(response => {
                setOutputs(response.data);
            })
            .catch(e => {
                console.log(e);
            });
        retrieveTables();
    };

    const sendEmail = () => {
        var templateParams = {
            name: 'James',
            notes: 'Check this out!'
        };

        emailjs.send('service_ugo88f3', 'template_m2cn0mv', templateParams, 'VpLX-RkmdBL6mEf_e')
            .then(function (response) {
                console.log('SUCCESS!', response.status, response.text);
            }, function (error) {
                console.log('FAILED...', error);
            });
    }

    const saveContact = () => {
        ContactService.create(currentContact)
            .then(response => {
                setCurrentContact({
                    persona_id: response.data.persona_id,
                    primo_contatto: response.data.primo_contatto,
                    titolo: response.data.titolo,
                    categoria: response.data.categoria,
                    nome: response.data.nome,
                    cognome: response.data.cognome,
                    attacco_lettera: response.data.attacco_lettera,
                    indirizzo: response.data.indirizzo,
                    civico: response.data.civico,
                    citta: response.data.citta,
                    cap: response.data.cap,
                    provincia: response.data.provincia,
                    telefono: response.data.telefono,
                    cellulare: response.data.cellulare,
                    societa: response.data.societa,
                    email: response.data.email,
                    sesso: response.data.sesso,
                    privacy: response.data.privacy,
                    provenienza: response.data.provenienza,
                    data_nascita: response.data.data_nascita,
                    luogo_nascita: response.data.luogo_nascita,
                    eta: response.data.eta,
                    codice_fiscale: response.data.codice_fiscale,
                    partita_iva: response.data.partita_iva,
                    legame: response.data.legame,
                    tipologia: response.data.tipologia,
                    donazione_id: response.data.donazione_id,
                    ragione_sociale: response.data.ragione_sociale,
                    fonte: response.data.fonte,
                    riconsocimento_invalidita: response.riconsocimento_invalidita,
                    perc_invalidita: response.perc_invalidita,
                    data_colloquio: response.data_colloquio,
                    data_socio: response.data_socio,
                    iscrizione_collocamento: response.iscrizione_collocamento,
                    pensione: response.pensione
                });
            })
            .catch(e => {
                console.log(e);
            });
    };

    useEffect(() => {
        if (id) {
            getContact(id);
        }
        retrieveTables();
    }, [id]);

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setCurrentContact({ ...currentContact, [name]: value });
        setDonations({ ...donations, [name]: value });
    };

    const [tables, setTables] = useState([]);

    const retrieveTables = () => {
        TableService.getAll()
            .then(response => {
                setTables(response.data);
            })
            .catch(e => {
                console.log(e);
            });
    };




    const [catSelected, setCatSelected] = useState([]);


    // selezione multipla con chip
    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };

    const theme = useTheme();

    function getStyles(name, catSelected, theme) {
        return {
            fontWeight:
                catSelected.indexOf(name) === -1
                    ? theme.typography.fontWeightRegular
                    : theme.typography.fontWeightMedium,
        };
    }

    const handleCategoryChange = (event) => {
        const {
            target: { value },
        } = event;
        setCatSelected(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
        setCurrentContact({ ...currentContact, categoria: event.target.value });
    };

    // end chip select


    const updateContact = () => {
        console.log(currentContact.categoria.toString());
        ContactService.update(currentContact.persona_id, {
            ...currentContact,
            categoria: currentContact.categoria.toString()
        })
            .then(response => {
                setMessage("The Contact was updated successfully!");
            })
            .catch(e => {
                console.log(e);
            });
    };

    const deleteContact = () => {
        ContactService.remove(currentContact.id)
            .then(response => {
                navigate("/Contacts");
            })
            .catch(e => {
                console.log(e);
            });
    };

    return (
        <TabContext value={(value) ? value : ((addAction) ? "4" : "1")} >
            <Box sx={{ width: '100%', bgcolor: 'background.paper' }}>
                <TabList onChange={handleChange} aria-label="lab API tabs example" centered >
                    <Tab label="Anagrafica" value="1" />
                    <Tab label="Info aggiuntive" value="3" />
                    <Tab label="Volontario/Familiare" value="6" />
                    <Tab label="Socio" value="7" />
                    <Tab label="Donazioni" value="2" />
                    <Tab label="Azioni" value="4" />
                    <Tab label="Uscite" value="5" />
                </TabList>

                <TabPanel value="1">
                    <TextField id="outlined-basic" label="Primo contatto" name="primo_contatto" type="date" InputLabelProps={{ shrink: true }} variant="outlined" style={{ marginBottom: "20px", marginRight: "20px" }} value={currentContact.primo_contatto} disabled={info} onChange={handleInputChange} />
                    <FormControl style={{ marginBottom: "20px", marginRight: "20px", minWidth: 120 }}>
                        <InputLabel id="demo-multiple-chip-label">Categoria</InputLabel>
                        <Select
                            labelId="demo-multiple-chip-label"
                            id="demo-multiple-chip"
                            multiple
                            value={(currentContact.categoria) ? currentContact.categoria : (catSelected ? catSelected : null)}
                            onChange={handleCategoryChange}
                            input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
                            renderValue={(selected) => (
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                    {selected.map((value) => (
                                        <Chip key={value} label={value} />
                                    ))}
                                </Box>
                            )}
                            MenuProps={MenuProps}
                        >
                            {tables.map((cat) =>
                                (cat.riferimento == 8) ? (
                                    <MenuItem
                                        key={cat.id}
                                        value={cat.campi}
                                        style={getStyles(cat, catSelected, theme)}
                                    >
                                        {cat.campi}
                                    </MenuItem>
                                ) : null)}
                        </Select>
                    </FormControl><br />
                    <FormControl sx={{ minWidth: "15ch", marginBottom: "20px", marginRight: "20px" }}>
                        <InputLabel id="demo-simple-select-autowidth-label">Titolo</InputLabel>
                        <Select
                            labelId="demo-simple-select-autowidth-label"
                            id="demo-simple-select-autowidth"
                            value={(currentContact.titolo) ? currentContact.titolo : ""}
                            autowidth
                            name="titolo"
                            onChange={handleInputChange}
                            label="Titolo"
                        >
                            {
                                tables.map((tab) =>
                                    (tab.riferimento == 9) ?
                                        <MenuItem value={tab.campi}>{tab.campi}</MenuItem>
                                        : null
                                )
                            }
                        </Select>
                    </FormControl>
                    <TextField id="outlined-basic" label="Nome" name="nome" variant="outlined" style={{ marginBottom: "20px", marginRight: "20px" }} value={currentContact.nome} disabled={info} onChange={handleInputChange} />
                    <TextField id="outlined-basic" label="Cognome" name="cognome" variant="outlined" style={{ marginBottom: "20px", marginRight: "20px" }} value={currentContact.cognome} disabled={info} onChange={handleInputChange} />
                    <FormControl sx={{ marginBottom: "20px", marginRight: "20px", minWidth: "10ch" }}>
                        <InputLabel id="demo-simple-select-autowidth-label">Sesso</InputLabel>
                        <Select
                            labelId="demo-simple-select-autowidth-label"
                            id="demo-simple-select-autowidth"
                            value={(currentContact.sesso) ? currentContact.sesso : ""}
                            autowidth
                            name="sesso"
                            onChange={handleInputChange}
                            label="Sesso"
                        >
                            <MenuItem value={"F"}>F</MenuItem>
                            <MenuItem value={"M"}>M</MenuItem>
                        </Select>
                    </FormControl>
                    <TextField id="outlined-basic" label="Data di nascita" variant="outlined" type="date" name="data_nascita" style={{ marginBottom: "20px", marginRight: "20px" }} InputLabelProps={{ shrink: true }} value={currentContact.data_nascita} disabled={info} onChange={handleInputChange} />
                    <TextField id="outlined-basic" label="Luogo di nascita" variant="outlined" name="luogo_nascita" style={{ marginBottom: "20px", marginRight: "20px" }} InputLabelProps={{ shrink: true }} value={currentContact.luogo_nascita} disabled={info} onChange={handleInputChange} />
                    <TextField id="outlined-basic" label="Codice fiscale" variant="outlined" name="codice_fiscale" style={{ marginBottom: "20px", marginRight: "20px" }} InputLabelProps={{ shrink: true }} value={currentContact.codice_fiscale} disabled={info} onChange={handleInputChange} />
                    <TextField id="outlined-basic" label="Telefono" variant="outlined" name="telefono" style={{ marginBottom: "20px", marginRight: "20px" }} value={currentContact.telefono} disabled={info} onChange={handleInputChange} />
                    <TextField id="outlined-basic" label="Cellulare" variant="outlined" name="cellulare" style={{ marginBottom: "20px", marginRight: "20px" }} value={currentContact.cellulare} disabled={info} onChange={handleInputChange} />
                    <TextField id="outlined-basic" label="Email" variant="outlined" name="email" style={{ marginBottom: "20px", marginRight: "20px" }} value={currentContact.email} disabled={info} onChange={handleInputChange} />
                    <TextField id="outlined-basic" label="Indirizzo" variant="outlined" name="indirizzo" style={{ marginBottom: "20px", marginRight: "20px" }} value={currentContact.indirizzo} disabled={info} onChange={handleInputChange} />
                    <TextField id="outlined-basic" label="Città" variant="outlined" name="citta" style={{ marginBottom: "20px", marginRight: "20px" }} value={currentContact.citta} disabled={info} onChange={handleInputChange} />
                    <TextField id="outlined-basic" label="Civico" variant="outlined" name="civico" style={{ marginBottom: "20px", marginRight: "20px" }} value={currentContact.civico} disabled={info} onChange={handleInputChange} />
                    <TextField id="outlined-basic" label="Provincia" variant="outlined" name="provincia" style={{ marginBottom: "20px", marginRight: "20px" }} value={currentContact.provincia} disabled={info} onChange={handleInputChange} />
                    <TextField id="outlined-basic" label="Cap" variant="outlined" name="cap" style={{ marginBottom: "20px", marginRight: "20px" }} value={currentContact.cap} disabled={info} onChange={handleInputChange} />
                </TabPanel>
                <TabPanel value="2">
                    <Donations donations={donations} donatore_id={currentContact.persona_id} />
                </TabPanel>
                <TabPanel value="3">
                    <TextField id="outlined-basic" label="Primo contatto" variant="outlined" type="date" name="primo_contatto" style={{ marginBottom: "20px", marginRight: "20px" }} value={currentContact.primo_contatto} disabled={info} onChange={handleInputChange} />
                    <TextField id="outlined-basic" label="Società" variant="outlined" name="societa" style={{ marginBottom: "20px", marginRight: "20px" }} value={currentContact.societa} disabled={info} onChange={handleInputChange} />
                    <TextField id="outlined-basic" label="Provenienza" variant="outlined" name="provenienza" style={{ marginBottom: "20px", marginRight: "20px" }} value={currentContact.provenienza} disabled={info} onChange={handleInputChange} />
                    <FormControl sx={{ marginBottom: "20px", marginRight: "20px", minWidth: "12ch" }}>
                        <InputLabel id="demo-simple-select-autowidth-label">Privacy</InputLabel>
                        <Select
                            labelId="demo-simple-select-autowidth-label"
                            id="demo-simple-select-autowidth"
                            value={(currentContact.privacy) ? currentContact.privacy : ""}
                            autowidth
                            name="privacy"
                            onChange={handleInputChange}
                            label="Privacy"
                        >
                            <MenuItem value={"si"}>si</MenuItem>
                            <MenuItem value={"no"}>no</MenuItem>
                        </Select>
                    </FormControl>
                    <TextField id="outlined-basic" label="Partita Iva" variant="outlined" name="partita_iva" style={{ marginBottom: "20px", marginRight: "20px" }} value={currentContact.partita_iva} disabled={info} onChange={handleInputChange} />
                    <TextField id="outlined-basic" label="Legame" variant="outlined" name="legame" style={{ marginBottom: "20px", marginRight: "20px" }} value={currentContact.legame} disabled={info} onChange={handleInputChange} />
                    <FormControl sx={{ marginBottom: "20px", marginRight: "20px", minWidth: "12ch" }}>
                        <InputLabel id="demo-simple-select-autowidth-label">Tipologia</InputLabel>
                        <Select
                            labelId="demo-simple-select-autowidth-label"
                            id="demo-simple-select-autowidth"
                            value={(currentContact.tipologia) ? currentContact.tipologia : ""}
                            autowidth
                            name="tipologia"
                            onChange={handleInputChange}
                            label="Tipologia"
                        >
                            <MenuItem value={"Niente"}>Niente</MenuItem>
                            <MenuItem value={"Direttamente"}>Direttamente</MenuItem>
                            <MenuItem value={"Familiare"}>Familiare</MenuItem>
                        </Select>
                    </FormControl>
                    <TextField id="outlined-basic" label="Fonte" variant="outlined" name="fonte" style={{ marginBottom: "20px", marginRight: "20px" }} value={currentContact.fonte} disabled={info} onChange={handleInputChange} />
                    <TextField id="outlined-basic" label="Ragione Sociale" variant="outlined" name="ragione_sociale" style={{ marginBottom: "20px", marginRight: "20px" }} value={currentContact.ragione_sociale} disabled={info} onChange={handleInputChange} />
                </TabPanel>
                <TabPanel value="4">
                    <Actions actions={actions} persona_id={currentContact.persona_id} />
                </TabPanel>
                <TabPanel value="5">
                    <Output contatto_id={currentContact.persona_id} />
                </TabPanel>
                <TabPanel value="6">
                    <TextField id="outlined-basic" label="Data colloquio" variant="outlined" type="date" InputLabelProps={{ shrink: true }} name="data_colloquio_vol" style={{ marginBottom: "20px", marginRight: "20px" }} value={currentContact.data_colloquio_vol} disabled={info} onChange={handleInputChange} /><br />
                    <FormControl sx={{ marginBottom: "20px", marginRight: "20px" }}>
                        <FormLabel id="demo-radio-buttons-group-label">Corso volontari</FormLabel>
                        <RadioGroup
                            aria-labelledby="demo-radio-buttons-group-label"
                            defaultValue={currentContact.corso_vol}
                            name="corso_vol"
                        >
                            <FormControlLabel value={true} control={<Radio />} label="Si" />
                            <FormControlLabel value={false} control={<Radio />} label="No" />
                        </RadioGroup>
                    </FormControl>
                    <TextField id="outlined-multiline-static" label="Info corso volontari" variant="outlined" fullWidth multiline rows={4} name="testo_corso_vol" style={{ marginBottom: "20px", marginRight: "20px" }} value={currentContact.testo_corso_vol} disabled={info} onChange={handleInputChange} /><br />
                    <FormControl sx={{ marginBottom: "20px", marginRight: "20px" }}>
                        <FormLabel id="demo-radio-buttons-group-label">Corso FAF</FormLabel>
                        <RadioGroup
                            aria-labelledby="demo-radio-buttons-group-label"
                            defaultValue={currentContact.corso_faf}
                            name="corso_faf"
                        >
                            <FormControlLabel value={true} control={<Radio />} label="Si" />
                            <FormControlLabel value={false} control={<Radio />} label="No" />
                        </RadioGroup>
                    </FormControl>
                    <TextField id="outlined-multiline-static" label="Info corso FAF" variant="outlined" fullWidth multiline rows={4} name="testo_corso_faf" style={{ marginBottom: "20px", marginRight: "20px" }} value={currentContact.testo_corso_faf} disabled={info} onChange={handleInputChange} /><br />
                </TabPanel>
                <TabPanel value="7">
                    <TextField id="outlined-basic" label="Data colloquio" variant="outlined" type="date" InputLabelProps={{ shrink: true }} name="data_colloquio_socio" style={{ marginBottom: "20px", marginRight: "20px" }} value={currentContact.data_colloquio_socio} disabled={info} onChange={handleInputChange} />
                    <TextField id="outlined-basic" label="Data socio" variant="outlined" type="date" InputLabelProps={{ shrink: true }} name="data_socio" style={{ marginBottom: "20px", marginRight: "20px" }} value={currentContact.data_socio} disabled={info} onChange={handleInputChange} /><br />
                    <FormControl sx={{ marginBottom: "20px", marginRight: "20px" }}>
                        <FormLabel id="demo-radio-buttons-group-label">Invalidità</FormLabel>
                        <RadioGroup
                            aria-labelledby="demo-radio-buttons-group-label"
                            name="invalidita"
                            defaultValue={currentContact.invalidita}
                        >
                            <FormControlLabel value={true} control={<Radio />} label="Si" />
                            <FormControlLabel value={false} control={<Radio />} label="No" />
                        </RadioGroup>
                    </FormControl>
                    <TextField id="outlined-multiline-static" label="% invalidità" variant="outlined" fullWidth multiline rows={4} name="perc_invalidita" style={{ marginBottom: "20px", marginRight: "20px" }} value={currentContact.perc_invalidita} disabled={info} onChange={handleInputChange} /><br />
                    <FormControl sx={{ marginBottom: "20px", marginRight: "20px" }}>
                        <FormLabel id="demo-radio-buttons-group-label">Iscrizione collocamento</FormLabel>
                        <RadioGroup
                            aria-labelledby="demo-radio-buttons-group-label"
                            defaultValue={currentContact.iscrizione_coll}
                            name="iscrizione_coll"
                        >
                            <FormControlLabel value={true} control={<Radio />} label="Si" />
                            <FormControlLabel value={false} control={<Radio />} label="No" />
                        </RadioGroup>
                    </FormControl>
                    <FormControl sx={{ marginBottom: "20px", marginRight: "20px" }}>
                        <FormLabel id="demo-radio-buttons-group-label">Pensione</FormLabel>
                        <RadioGroup
                            aria-labelledby="demo-radio-buttons-group-label"
                            defaultValue={currentContact.pensione}
                            name="pensione"
                        >
                            <FormControlLabel value={true} control={<Radio />} label="Si" />
                            <FormControlLabel value={false} control={<Radio />} label="No" />
                        </RadioGroup>
                    </FormControl>
                </TabPanel>
                <Button variant="contained" onClick={(currentContact.persona_id) ? updateContact : saveContact}>{(currentContact.persona_id) ? "Aggiorna" : "Salva"}</Button>
            </Box>
        </TabContext >
    );
};

export default Contact;